import {staffService} from "./service/staff";
import * as R from 'ramda';
import {ASPECTUSER, NEED_APPLICATION, STAFF_ORDER_STATUS, STAFF_ORDER_STATUS_FOR_E} from "@/modules/staff/config";

export const DispatchingCarMixin = {
    methods: {
        getDispatchingCarDesc(item) {
            let name = item.dispatchingCarDesc || item.hopeDispatchingCarDesc || "";
            if (!name) return "";
            const {hopeHosName, initHosName} = item;
            name = name.replace("上级医院", hopeHosName || "对方医院");
            name = name.replace("下级医院", initHosName || "本院");
            return name;
        }
    },
}

export const MapMixin = {
    props: {
        info: {
            type: Object,
            default: () => Object.create(null)
        },
    },
    data() {
        return {
            timer: null,
            map: null,
            result: {},
            mockTimes: 0,
            polyline: null,
            timeout: 100000
        }
    },
    computed: {
        traceList() {
            return this.info.traceList || [];
        },
        routes() {
            return this.result.routes || [];
        },
        route() {
            return this.routes[0] || {};
        },
        distance() {
            let distance = this.route.distance || 0;
            return (distance / 1000).toFixed(1) + '公里';
        },
        time() {
            let time = this.route.time || 0;
            return (time / 60).toFixed(0) + '分钟';
        },
        showTime() {
            return ['IN_TRANSIT', 'NEED_RECEIVE_AND_SEND'].includes(this.info.referralStatus)
        },
    },
    beforeDestroy() {
        this.map.destroy();
        this.clear();
    },
    methods: {
        setPolyline(pathParam) {
            if (this.polyline) this.polyline.setMap(null);
            this.polyline = new AMap.Polyline({
                path: pathParam,
                isOutline: true,
                showDir: true,
                outlineColor: "#ffeeff",
                borderWeight: 3,
                strokeColor: "rgb(234,42,71)",
                strokeOpacity: 1,
                strokeWeight: 6,
                // 折线样式还支持 'dashed'
                strokeStyle: "solid",
                // strokeStyle是dashed时有效
                strokeDasharray: [10, 5],
                lineJoin: "round",
                lineCap: "round",
                zIndex: 50
            });
            this.polyline.setMap(this.map);
        },
        async getDriving() {
            this.mockTimes++;
            const {traceList} = this.info;
            if (!traceList || !traceList.length) return;
            const trace = traceList[0];
            const oldPoints = await staffService.trace(trace.id);
            let points = oldPoints;
            Log('old', points);
            if (points && points.length) {
                const pathParam = points.map(r => {
                    return r.location.split(",");
                });
                this.setPolyline(pathParam);
                // 缩放地图到合适的视野级别
                this.getHopeDriving(points);
                this.addMakers();
                this.addJhcMaker([...pathParam].pop());
                //this.map.setFitView();
                this.clear();
                this.timer = setTimeout(() => {
                    this.getDriving();
                }, this.timeout);
            }
        },

        clear() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        },

        addMakers() {
            let start = this.info.initHosAddressLocation;
            let end = this.info.hopeHosAddressLocation;
            let startIcon = new AMap.Icon({
                size: new AMap.Size(19, 30),
                // 图标所用图片大小
                imageSize: new AMap.Size(19, 30),
                image: 'https://webapi.amap.com/theme/v1.3/markers/b/start.png'
            });
            let endIcon = new AMap.Icon({
                size: new AMap.Size(19, 30),
                // 图标所用图片大小
                imageSize: new AMap.Size(19, 30),
                image: 'https://webapi.amap.com/theme/v1.3/markers/b/end.png'
            });
            [start, end].forEach((r, i) => {
                new AMap.Marker({
                    icon: i === 0 ? startIcon : endIcon,
                    position: r.split(','),
                    map: this.map
                })
            })
        },

        addJhcMaker(p2) {
            let p1 = this.info.initHosAddressLocation;
            p1 = p1.split(',');
            const icon = new AMap.Icon({
                size: new AMap.Size(60, 60),
                // 图标所用图片大小
                imageSize: new AMap.Size(60, 60),
                image: 'https://nethosweb.diandianys.com/img/ambulance.png?t=2'
            });
            const dis = AMap.GeometryUtil.distance(p1, p2);
            Log('p1', p2, dis);
            if (dis > 1000) {
                if (this.jhcMaker)
                    this.map && this.map.remove(this.jhcMaker);
                this.jhcMaker = new AMap.Marker({
                    icon,
                    position: p2
                })
                this.map && this.map.add(this.jhcMaker);
                this.map && this.map.setZoomAndCenter(15, p2);
            }
        },

        getHopeDriving(points) {
            let start = this.info.initHosAddressLocation;
            let end = this.info.hopeHosAddressLocation;
            if (points.length) start = [...points].pop();
            if (start && start.location) start = start.location;
            start = start.split(",");
            end = end.split(",");
            Log('start,end', start, end);
            AMap.plugin("AMap.Driving", () => {
                Log('this.drving', this.driving);
                if (this.driving) this.map && this.map.remove(this.driving);
                this.driving = new AMap.Driving({
                    map: this.map,
                    autoFitView: false,
                    hideMarkers: true
                });
                this.driving.search(
                    new AMap.LngLat(...start),
                    new AMap.LngLat(...end),
                    (status, result) => {
                        this.result = result || {};
                    }
                );
            });
        },
    },
}
/**
 * 处理 远程会诊，急救转诊 列表页
 * @description 状态栏，是否急救页
 * @type {{data(): {hasEmergencyReferral: boolean}, watch: {$route(): void}, methods: {setStatusArray(*, *): void, setHasEmergencyReferral(): void}}}
 */
export const hasEmergencyReferralMixin = {
    data() {
        return {
            hasEmergencyReferral: true
        }
    },
    computed: {
        prefix() {
            return this.hasEmergencyReferral ? '急重症转诊-' : '远程会诊中心-'
        }
    },
    methods: {
        setHasEmergencyReferral() {
            this.hasEmergencyReferral = !this.$route.path.includes('consult');
        },
        setStatusArray() {
            const aspectUser = this.aspectUser;
            let list = R.clone(STAFF_ORDER_STATUS);
            let listForE = R.clone(STAFF_ORDER_STATUS_FOR_E);
            // 急救管理员-远程会诊-发起
            if (this.hasEmergencyReferral === false && aspectUser === ASPECTUSER.init && this.isAID_ADM) {
                list.unshift(NEED_APPLICATION);
                this.statusArr = list;
                this.status = NEED_APPLICATION.id;
            }
            // 急救管理员-远程会诊-接收
            if (this.hasEmergencyReferral === false && aspectUser === ASPECTUSER.accept && this.isAID_ADM) {
                list.shift();
                this.statusArr = list;
                this.status = list[0].id;
            }
            // 急救管理员-急救转诊-发起
            if (this.hasEmergencyReferral === true && aspectUser === ASPECTUSER.init && this.isAID_ADM) {
                this.statusArr = list;
                this.status = list[0].id;
            }

            // 急救管理员-急救转诊-接收
            if (this.hasEmergencyReferral === true && aspectUser === ASPECTUSER.accept && this.isAID_ADM) {
                list.shift();
                this.statusArr = list;
                this.status = list[0].id;
            }

            // 审核管理员-急救转诊-接收
            if (this.hasEmergencyReferral === true && aspectUser === ASPECTUSER.accept && this.isAID_E_ADM) {
                //list.shift();
                this.statusArr = listForE;
                this.status = listForE[0].id;
            }

            // 审核管理员-远程会诊-接收
            if (this.hasEmergencyReferral === false && aspectUser === ASPECTUSER.accept && this.isAID_E_ADM) {
                //list.shift();
                this.statusArr = listForE;
                this.status = listForE[0].id;
            }
        }
    },
    watch: {
        $route() {
            this.setHasEmergencyReferral();
            this.setStatusArray();
            this.page.pageNum = 1;
            this.page.pageSize = 9;
            this.count();
            this.getList();
        }
    }
}
